<template>
	<div class="w-full d-flex flex-column align-items-center">
		<Toolbar class="toolbar">
			<div class="w-full h-full d-flex items-center justify-end">
				<button
					class="btn btn-tool"
					@click="New"
				>
					<i class="far fa-plus"></i>
				</button>
			</div>
		</Toolbar>
		<div class="w-full px-3 pt-3">
			<div
				v-if="stamps.length"
				class="flex flex-col gap-4"
			>
				<div
					v-for="stamp in stamps"
					:key="stamp.id"
					:class="[
						'stamp-card',
						{
							active:
								selected_stamp &&
								selected_stamp.id === stamp.id,
						},
					]"
					@click="SelectStampCard(stamp)"
				>
					<div class="flex items-center">
						<div class="visual-stamp-wrapper">
							<div class="visual-stamp-preview">
								<div
									class="stamp-line-preview"
									v-html="stamp.line_one"
								></div>
								<div
									class="stamp-line-preview"
									v-html="stamp.line_two"
								></div>
								<div
									class="stamp-line-preview"
									v-html="stamp.line_three"
								></div>
							</div>
							<div
								class="visual-signature-preview relative overflow-hidden"
							>
								<img
									v-if="stamp.signature"
									:src="stamp.signature"
									alt="signature"
								/>
							</div>
						</div>
					</div>
					<div class="flex items-center">
						<span
							v-if="
								stamp.professional_advice &&
								!stamp.uf_professional_advice
							"
							class="card-label"
							>{{ stamp.professional_advice_description }} -
							:</span
						>
						<span
							v-else-if="
								stamp.professional_advice &&
								stamp.uf_professional_advice
							"
							class="card-label"
							>{{ stamp.professional_advice_description }} -
							{{ stamp.uf_professional_advice }} :</span
						>
						<span class="card-value"
							><strong>{{ stamp.number || '-' }}</strong></span
						>
					</div>
					<div class="flex items-center">
						<span
							v-if="stamp.rqe && stamp.uf_rqe"
							class="card-label"
							>RQE - {{ stamp.uf_rqe }} :</span
						>
						<span
							v-else-if="stamp.rqe && !stamp.uf_rqe"
							class="card-label"
							>RQE - :</span
						>
						<span class="card-value"
							><strong>{{ stamp.rqe || '-' }}</strong></span
						>
					</div>
					<div class="flex justify-end gap-10">
						<button
							class="btn-edit"
							@click.stop="Edit(stamp)"
						>
							<i class="fas fa-pen"></i>
						</button>
						<button
							class="btn-delete"
							@click.stop="DeleteStamp(stamp)"
						>
							<i class="fas fa-trash-alt"></i>
						</button>
					</div>
				</div>
			</div>
			<div
				v-else
				class="w-full px-3"
			>
				<div
					class="stamp-card"
					style="justify-content: center"
				>
					Nenhum carimbo cadastrado.
				</div>
			</div>
		</div>

		<StampsModal
			v-if="showStampsModal"
			:stamp="selectedStamp"
			@close="showStampsModal = false"
		/>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import Toolbar from '@/components/shared/layout/ToolBar.vue'
	import StampsModal from './components/StampsModal.vue'
	import { useConfirmation, useDeleteAlert, useError } from '@/composables'

	export default {
		name: 'Stamps',
		components: {
			Toolbar,
			StampsModal,
		},
		data() {
			return {
				selectedStamp: null,
				showStampsModal: false,
			}
		},
		computed: {
			...mapGetters('auth', [
				'stamps',
				'account',
				'requester_selected_id',
				'selected_stamp',
			]),
		},
		methods: {
			...mapActions('auth', ['GetAuthAccount', 'SetSelectedStamp']),
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			New() {
				this.selectedStamp = {
					name: this.account?.name?.toUpperCase() || '',
					line_one: this.BuildDefaultStampLine(
						this.account?.name || ''
					),
				}
				this.showStampsModal = true
			},
			BuildDefaultStampLine(value) {
				const content = String(value || '').trim()

				if (!content) return ''

				if (typeof document === 'undefined') {
					return `<p style="font-size: 10px;">${content}</p>`
				}

				const div = document.createElement('div')
				div.textContent = content

				return `<p style="font-size: 10px;">${div.innerHTML}</p>`
			},
			Edit(stamp) {
				this.selectedStamp = {
					...stamp,
					name: this.account?.name?.toUpperCase() || '',
				}
				this.showStampsModal = true
			},
			async SelectStampCard(stamp) {
				if (!stamp || !stamp.id) return

				this.StartLoading()

				await this.SetSelectedStamp({
					stamp,
					requester_id: this.requester_selected_id,
				})

				await this.GetAuthAccount()

				this.FinishLoading()

				useConfirmation()
			},
			async DeleteStamp(stamp) {
				if (!stamp || !stamp.id) return

				useDeleteAlert({
					title: 'DESEJA MESMO DELETAR ESTE CARIMBO?',
				}).then(async result => {
					if (result.isConfirmed) {
						this.StartLoading()

						await window.api
							.call('post', '/delete-stamp', {
								stamp_id: stamp.id,
								account_id: this.account.id,
							})
							.then(async ({ data }) => {
								if (data.response) {
									await this.GetAuthAccount()
									useConfirmation()
								} else {
									useError(
										'HOUVE UM ERRO AO EXCLUIR, CONTATE O SUPORTE.'
									)
								}
							})
							.finally(() => {
								this.FinishLoading()
							})
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.btn-tool {
		width: 1.875rem !important;
		height: 1.875rem !important;

		i {
			font-size: 1rem !important;
		}
	}

	.stamp-card {
		background-color: var(--gridBackgroundColor);
		border: 1px solid var(--newPrimaryBackgroundColor);
		transition: background-color 0.1s;
		min-height: 5rem;
		width: 100%;
		display: grid;
		grid-template-columns: 3.5fr 1.5fr 1.5fr 1fr;
		align-items: center;
		padding: 0.625rem 0.75rem;
		cursor: pointer;
		border-radius: 0.5rem;
		font-family: 'Avenir Next', sans-serif !important;

		.visual-stamp-wrapper {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			gap: 0.625rem;
			width: 100%;

			.visual-stamp-preview,
			.visual-signature-preview {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				background-color: var(--gridBackgroundColor) !important;
				color: var(--textColor);
				height: 3.313rem;
				width: 9rem;
				overflow: hidden;
				border-radius: 0.25rem;
				border: 1px solid var(--textColor) !important;
				flex-shrink: 0;
				transition: color 0.1s, border-color 0.1s;

				img {
					display: block;
					width: 100%;
					height: 100%;
					// object-fit: contain;
				}

				.stamp-line-preview {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					line-height: 1;
					max-height: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					width: 100%;
					padding: 0;
					box-sizing: border-box;
				}
			}
		}

		.card-label {
			color: var(--textColor);
			font-size: 0.938rem;
			font-weight: 300;
			margin-right: 0.375rem;
		}

		.card-value {
			color: var(--textColor);
			font-size: 1rem;
			white-space: nowrap;
			font-weight: bold;
		}

		.btn-edit {
			background-color: transparent;
			border: none;

			i {
				font-size: 0.875rem;
				line-height: 1.25rem;
				color: var(--newPrimaryBackgroundColor);

				&:hover {
					color: var(--newPrimaryHoverColor);
				}
			}
		}

		.btn-delete {
			background-color: transparent;
			border: none;

			i {
				font-size: 0.875rem;
				line-height: 1.25rem;
				color: var(--dangerBackgroundColor);

				&:hover {
					color: var(--deleteHoverColor);
				}
			}
		}
	}

	.stamp-card.active {
		background-color: var(--newColor);

		.card-label,
		.card-value {
			color: var(--textActiveColor);
		}

		.btn-edit:hover {
			i {
				color: var(--backgroundColor);
			}
		}
	}
</style>

<style lang="css">
	.visual-stamp-preview p {
		margin: 0 !important;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#stamps-modal .ql-editor {
		height: 5vh !important;
		/* overflow: hidden; */
		/* height: auto !important; */
		/* min-height: 5vh !important;
		max-height: 6vh; */
		overflow: auto !important;
		white-space: pre-wrap !important;
		overflow-wrap: break-word !important;
		word-break: break-word !important;
		box-sizing: border-box;
		width: 100%;
	}

	#stamps-modal .ql-container.ql-snow {
		border-color: var(--elementsBorderColor) !important;
		border-top: none !important;
	}

	#stamps-modal .ql-toolbar.ql-snow {
		padding: 0.188rem 8px !important;
	}

	#stamps-modal .ql-snow .ql-picker.ql-size {
		width: 2.813rem !important;
	}

	#stamps-modal .form-group.form-group--active .ql-container.ql-snow,
	#stamps-modal .ql-container.ql-snow:has(.ql-editor:not(.ql-blank)) {
		border-color: var(--newColor) !important;
		background-color: var(--newColor) !important;
	}

	#stamps-modal
		.form-group.form-group--active
		.ql-container.ql-snow
		.ql-editor,
	#stamps-modal
		.ql-container.ql-snow:has(.ql-editor:not(.ql-blank))
		.ql-editor {
		background-color: var(--newColor) !important;
		color: var(--fontColorActiveSelected) !important;
		caret-color: var(--fontColorActiveSelected) !important;
		border-radius: 0 0 8px 8px !important;
		font-family: 'Avenir Next Light', sans-serif;
		font-weight: 600 !important;
	}

	#stamps-modal .editor-container .editor-toolbar.ql-toolbar,
	#stamps-modal .editor-container .editor-toolbar.ql-toolbar.ql-snow,
	#stamps-modal .editor-container .ql-snow.ql-toolbar,
	#stamps-modal .editor-container .ql-snow .ql-toolbar {
		border-color: var(--elementsBorderColor) !important;
		background-color: var(--backgroundColor) !important;
	}

	#stamps-modal .editor-container.field-error .editor-toolbar.ql-toolbar,
	#stamps-modal
		.editor-container.field-error
		.editor-toolbar.ql-toolbar.ql-snow,
	#stamps-modal .editor-container.field-error .ql-snow.ql-toolbar,
	#stamps-modal .editor-container.field-error .ql-snow .ql-toolbar {
		border-top-color: var(--requiredColor) !important;
		border-left-color: var(--requiredColor) !important;
		border-right-color: var(--requiredColor) !important;
		background-color: var(--backgroundColor) !important;
	}

	#stamps-modal .editor-container.field-error .ql-container.ql-snow {
		border-color: var(--requiredColor) !important;
		background-color: var(--backgroundColor) !important;
	}

	#stamps-modal .editor-container.field-error .ql-editor {
		background-color: var(--newBackground) !important;
		border-radius: 0px 0px 8px 8px !important;
	}

	#stamps-modal
		.editor-container.field-error.is-active
		.editor-toolbar.ql-toolbar,
	#stamps-modal
		.editor-container.field-error.is-active
		.editor-toolbar.ql-toolbar.ql-snow,
	#stamps-modal .editor-container.field-error.is-active .ql-snow.ql-toolbar,
	#stamps-modal .editor-container.field-error.is-active .ql-snow .ql-toolbar {
		border-top-color: var(--newColor) !important;
		border-left-color: var(--newColor) !important;
		border-right-color: var(--newColor) !important;
	}

	#stamps-modal
		.editor-container.field-error.is-active
		.ql-container.ql-snow {
		border-color: var(--newColor) !important;
		background-color: var(--newColor) !important;
	}

	#stamps-modal .editor-container.field-error.is-active .ql-editor {
		background-color: var(--newColor) !important;
		color: var(--fontColorActiveSelected) !important;
		caret-color: var(--fontColorActiveSelected) !important;
	}

	#stamps-modal .editor-container.is-active .ql-toolbar,
	#stamps-modal .editor-container.is-active .ql-snow.ql-toolbar,
	#stamps-modal .editor-container.is-active .editor-toolbar.ql-toolbar {
		border-color: var(--newColor) !important;
	}

	#stamps-modal .editor-container .editor-toolbar.ql-toolbar button,
	#stamps-modal .editor-container .editor-toolbar.ql-toolbar.ql-snow button,
	#stamps-modal .editor-container .ql-snow.ql-toolbar button {
		color: var(--elementsBorderColor) !important;
	}

	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar
		button
		.ql-stroke,
	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar
		span.ql-picker
		.ql-stroke,
	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar.ql-snow
		button
		.ql-stroke,
	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar.ql-snow
		span.ql-picker
		.ql-stroke,
	#stamps-modal .editor-container .ql-snow.ql-toolbar button .ql-stroke,
	#stamps-modal
		.editor-container
		.ql-snow.ql-toolbar
		span.ql-picker
		.ql-stroke,
	#stamps-modal .editor-container .ql-snow .ql-toolbar button .ql-stroke,
	#stamps-modal
		.editor-container
		.ql-snow
		.ql-toolbar
		span.ql-picker
		.ql-stroke {
		stroke: var(--elementsBorderColor);
	}

	#stamps-modal
		.editor-container
		.ql-snow.ql-toolbar
		span.ql-picker:hover
		.ql-stroke {
		stroke: var(--newColor) !important;
	}

	#stamps-modal .editor-container .editor-toolbar.ql-toolbar button.ql-active,
	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar.ql-snow
		button.ql-active,
	#stamps-modal .editor-container .ql-snow.ql-toolbar button.ql-active,
	#stamps-modal
		.editor-container
		.ql-snow.ql-toolbar
		> button.ql-italic.ql-active
		> svg
		> line {
		background-color: unset;
		color: var(--newColor) !important;
		stroke: var(--newColor) !important;
	}

	#stamps-modal
		.editor-container
		.ql-snow.ql-toolbar
		.ql-picker
		.ql-picker-label.ql-active {
		color: var(--newColor) !important;
	}
</style>
